import { UrlUtils } from "@allwyn/utils/url";

export const useDsModalVideoTools = (urlOrCode: string) => {
    const embedVideoUrl = (() => {
        if (urlOrCode.indexOf("embed") >= 0) return urlOrCode;

        const shortsMatch = /youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/.exec(urlOrCode);
        if (shortsMatch) {
            return `https://www.youtube-nocookie.com/embed/${shortsMatch[1]}?autoplay=1`;
        }

        const code = UrlUtils.getQueryString("v", urlOrCode);
        return `https://www.youtube-nocookie.com/embed/${code || urlOrCode}?autoplay=1`;
    })();

    return {
        embedVideoUrl,
    };
};
